"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = tslib_1.__importDefault(require("../utils"));
var align_1 = tslib_1.__importDefault(require("./align"));
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */
function alignPoint(el, tgtPoint, align, alignConfig, adjustCenter) {
    var pageX;
    var pageY;
    var doc = utils_1.default.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = utils_1.default.getWindowScrollLeft(win);
    var scrollY = utils_1.default.getWindowScrollTop(win);
    var viewportWidth = utils_1.default.viewportWidth(win);
    var viewportHeight = utils_1.default.viewportHeight(win);
    if ('pageX' in tgtPoint) {
        pageX = tgtPoint.pageX;
    }
    else {
        pageX = scrollX + tgtPoint.clientX;
    }
    if ('pageY' in tgtPoint) {
        pageY = tgtPoint.pageY;
    }
    else {
        pageY = scrollY + tgtPoint.clientY;
    }
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0,
    };
    var pointInView = pageX >= 0 &&
        pageX <= scrollX + viewportWidth &&
        pageY >= 0 &&
        pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [align.points[0], 'cc'];
    return (0, align_1.default)(el, tgtRegion, tslib_1.__assign(tslib_1.__assign({}, align), { points: points }), pointInView, alignConfig, adjustCenter);
}
exports.default = alignPoint;
//# sourceMappingURL=alignPoint.js.map